<template>
    <div class="project-container" v-loading="loading" ref="container">
        <div class="project-content" v-if="data">
            <div class="project" v-for="item in data.data.data" :key="item.id">
                <div class="img">
                    <a :href="item.url" target="_blank"><img alt="" v-lazy="item.thumb" class='project-img'></a>
                </div>
                <div class="project-info">
                    <div class="title">
                        <a class="project-title" :href="item.github" target="_blank">{{ item.name }}</a>
                    </div>
                    <div class="github-link" v-if="item.github">
                        <a :href="item.github" target="_blank">github</a>
                    </div>
                    <div class="project-des">
                        <div v-for="(item, i) in item.description" :key="i" class="single-des">
                            {{ item }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { mapState } from 'vuex';
import eventBus from '@/eventBus';
export default {
    computed: mapState('projects', ['data', 'loading']),
    created() {
        this.$store.dispatch('projects/getData');
        eventBus.$on('setScrollTop', this.handleTotop)
    },
    mounted() {
        this.$refs.container.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
        eventBus.$emit('projectScroll');
        this.$refs.container.removeEventListener('scroll', this.handleScroll);
        eventBus.$off('setScrollTop', this.handleTotop)
    },
    methods: {
        handleScroll() {
            eventBus.$emit('projectScroll', this.$refs.container)
        },
        handleTotop(scrollPos) {
            if (this.$refs.container) {
                this.$refs.container.scrollTop = scrollPos
            }

        }
    }
}
</script>
  
<style lang="less" scoped>
.project-container {
    scroll-behavior: smooth;
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 40px;
    box-sizing: border-box;

    .project-content {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }

    .project {
        transition: .5s;
        margin-top: 10px;
        display: flex;
        box-sizing: border-box;
        padding: 20px 0px;

        .img {
            min-width: 300px;
            height: 200px;
            margin: 0 20px;

            a {
                display: block;
                width: 100%;
                height: 100%
            }

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .title {
        font-size: 20px;
        font-weight: bolder;
    }

    .github-link {
        margin: 5px 0;

        a {
            text-decoration: none;
            color: #33CCCC
        }
    }

    .project-des {
        font-size: 16px;
    }

    .single-des {
        margin: 15px 0;
    }

    .project-title {
        color: #000;
        text-decoration: none;
    }

    .project:hover {
        border: 1px solid #000;
        box-shadow: -1px 1px 5px #000;
        transform: scale(1.01) translate(3px, -3px);
    }
}
</style>